<template>
    <header>
        <div class="row container-fluid mt-3">
            <!-- <a class="navbar-brand d-flex" href="/">
                <div class="col-10">
                    <img :src="require('@/assets/css/img/logoCAS.png')" height="70px"/>
                </div>
                <div class="col-2">
                    <img :src="require('@/assets/css/img/logoVC.png')" height="60px" />
                </div>
            </a> -->
            <!-- <hr> -->
            <div class="col-10">
                <a class="navbar-brand" href="https://www.dipcas.es/es/castellon-senior.html" target=”_blank”>
                        <img :src="require('@/assets/img/logoCAS1a.png')" height="65px"/>
                </a>
                <a class="navbar-brand ml-3" href="https://www.dipcas.es/va/ " target=”_blank”>
                    <img :src="require('@/assets/img/logoCAS1b.png')" height="35px"/>
                </a>
            </div>
            <div class="col-2">
                <a class="navbar-brand d-flex" href="https://viajescemo.com" target=”_blank”>
                    <img :src="require('@/assets/img/logoVC.png')" height="60px" />
                </a>
            </div>

        </div>
    </header>
</template>

<script>
export default {

}
</script>